import { hasPrivilege, ASSET_WRITE, isTeamManager } from 'utils/privileges';
import config from 'utils/config';
import store from 'utils/store';
import getUserId from 'utils/session/getUserId';
export function getIsAssetEditableInHub(_ref) {
  var ownerTeamId = _ref.ownerTeamId,
    domain_id = _ref.domain_id,
    _ref$allowEditingDist = _ref.allowEditingDistributedPlaylists,
    allowEditingDistributedPlaylists = _ref$allowEditingDist === void 0 ? false : _ref$allowEditingDist,
    authorId = _ref.authorId;
  if (!allowEditingDistributedPlaylists) {
    var isDistributedAsset = domain_id && +store('domainId') !== +domain_id;
    if (isDistributedAsset) {
      return false;
    }
  }

  // Can edit an asset - is asset admin or team manager and feature flags are on
  var isAssetAdmin = hasPrivilege(ASSET_WRITE);
  var isPrivilegedTeamManager = Boolean(ownerTeamId) && isTeamManager(ownerTeamId) && config.managersCreateAssets;
  var isAuthor = getUserId() === authorId;
  return isAssetAdmin || isPrivilegedTeamManager || isAuthor;
}